export default __webpack_public_path__ + "9d25d034176eaf46cc46326712361f2d.svg";